const uiScreens = [
  {
    label: 'Inventory Dashboard',
    icon: 'ri-layout-grid-line',
    image: 'https://public.readdy.ai/ai/img_res/ff12480c5026a3cc36549baa4412acf9.jpg',
  },
  {
    label: 'Vehicle Tracking',
    icon: 'ri-car-line',
    image: 'https://readdy.ai/api/search-image?query=vehicle%20tracking%20software%20interface%20showing%20car%20VIN%20history%20service%20records%20dark%20UI%20with%20blue%20accents%20automotive%20software%20screenshot%20professional&width=400&height=250&seq=ui002&orientation=landscape',
  },
  {
    label: 'POS System',
    icon: 'ri-qr-scan-2-line',
    image: 'https://readdy.ai/api/search-image?query=automotive%20POS%20point%20of%20sale%20software%20interface%20dark%20theme%20showing%20invoice%20receipt%20barcode%20scanner%20modern%20retail%20tech%20screenshot%20professional&width=400&height=250&seq=ui003&orientation=landscape',
  },
  {
    label: 'Mobile Technician App',
    icon: 'ri-smartphone-line',
    image: 'https://readdy.ai/api/search-image?query=mobile%20app%20for%20automotive%20technicians%20showing%20job%20cards%20vehicle%20history%20dark%20interface%20professional%20screenshot&width=400&height=250&seq=ui004&orientation=landscape',
  },
];

const SuccessStory = () => {
  return (
    <section className="bg-[#0a1628] py-24 px-6" id="success">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#f97316]/10 border border-[#f97316]/25 rounded-full mb-5">
            <i className="ri-star-line text-[#f97316] text-sm"></i>
            <span className="text-[#f97316] text-xs font-semibold tracking-widest uppercase">Client Success</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Real Results from
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#3b82f6] to-[#f97316]"> South African Businesses</span>
          </h2>
        </div>

        {/* Case Study Card */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          <div className="relative rounded-2xl overflow-hidden h-72 lg:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20South%20African%20auto%20parts%20store%20interior%20with%20organized%20shelving%20and%20staff%20members%20working%20on%20tablets%20showing%20inventory%20software%20Johannesburg%20modern%20warehouse%20dark%20atmosphere%20with%20blue%20lighting%20ultra%20realistic%20photography&width=700&height=500&seq=ss001&orientation=landscape"
              alt="AutoParts SA"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-transparent to-transparent"></div>
            <div className="absolute bottom-5 left-5 flex gap-3">
              <div className="bg-[#0a1628]/80 backdrop-blur-sm border border-white/10 rounded-xl px-4 py-3 text-center">
                <div className="text-[#f97316] font-bold text-xl">40%</div>
                <div className="text-gray-400 text-xs">More Efficient</div>
              </div>
              <div className="bg-[#0a1628]/80 backdrop-blur-sm border border-white/10 rounded-xl px-4 py-3 text-center">
                <div className="text-green-400 font-bold text-xl">65%</div>
                <div className="text-gray-400 text-xs">Fewer Stockouts</div>
              </div>
              <div className="bg-[#0a1628]/80 backdrop-blur-sm border border-white/10 rounded-xl px-4 py-3 text-center">
                <div className="text-[#3b82f6] font-bold text-xl">3x</div>
                <div className="text-gray-400 text-xs">Locations Synced</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-center bg-[#0f2040] border border-white/10 rounded-2xl p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-[#f97316]/15 rounded-xl">
                <i className="ri-building-4-line text-[#f97316] text-2xl"></i>
              </div>
              <div>
                <div className="text-white font-bold text-lg">AutoParts SA</div>
                <div className="text-gray-400 text-sm flex items-center gap-1">
                  <i className="ri-map-pin-line text-xs"></i>
                  Johannesburg, South Africa
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-white mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              From Manual Chaos to Digital Clarity
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              AutoParts SA improved efficiency by <strong className="text-[#f97316]">40%</strong> after switching to PRODIFY. With real-time stock tracking across 3 locations, they reduced stockouts by <strong className="text-green-400">65%</strong> and significantly improved customer experience through the online availability portal.
            </p>

            {/* Quote */}
            <div className="bg-[#0a1628] border-l-4 border-[#f97316] rounded-r-xl p-5 mb-6">
              <i className="ri-double-quotes-l text-[#f97316] text-2xl mb-2 block"></i>
              <p className="text-gray-200 text-sm italic leading-relaxed">
                "PRODIFY transformed our business. We can now track every part, manage suppliers efficiently, and our customers love the online portal."
              </p>
              <div className="flex items-center gap-3 mt-4">
                <div className="w-8 h-8 flex items-center justify-center bg-[#f97316]/20 rounded-full">
                  <i className="ri-user-line text-[#f97316] text-sm"></i>
                </div>
                <div>
                  <div className="text-white text-sm font-semibold">Thabo Mokoena</div>
                  <div className="text-gray-500 text-xs">Owner, AutoParts SA</div>
                </div>
              </div>
            </div>

            <a
              href="#demo"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-semibold rounded-lg transition-all duration-200 text-sm whitespace-nowrap self-start"
            >
              <i className="ri-arrow-right-line"></i>
              Get Similar Results
            </a>
          </div>
        </div>

        {/* UI Mockup highlights */}
        <div className="bg-[#060f1e] rounded-2xl border border-white/10 p-8 lg:p-10">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
              See PRODIFY in Action
            </h3>
            <p className="text-gray-400 text-sm mt-2">Every screen designed for speed and simplicity</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {uiScreens.map((screen, i) => (
              <div
                key={i}
                className="relative rounded-xl overflow-hidden aspect-video bg-[#0a1628] border border-white/10 group cursor-pointer hover:border-[#3b82f6]/40 transition-all duration-300"
              >
                <img
                  src={screen.image}
                  alt={screen.label}
                  className="w-full h-full object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#060f1e]/90 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center bg-[#3b82f6]/20 rounded-md">
                    <i className={`${screen.icon} text-[#3b82f6] text-xs`}></i>
                  </div>
                  <span className="text-white text-xs font-medium">{screen.label}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Integration logos */}
          <div className="border-t border-white/10 pt-8">
            <p className="text-gray-500 text-xs text-center uppercase tracking-widest mb-5">Integrates With</p>
            <div className="flex flex-wrap justify-center gap-6">
              {[
                { icon: 'ri-whatsapp-line', label: 'WhatsApp' },
                { icon: 'ri-file-text-line', label: 'Xero Accounting' },
                { icon: 'ri-qr-code-line', label: 'POS Systems' },
                { icon: 'ri-cloud-line', label: 'Cloud Backup' },
                { icon: 'ri-mail-send-line', label: 'Email Alerts' },
                { icon: 'ri-bank-card-line', label: 'PayFast / EFT' },
              ].map((intg, i) => (
                <div key={i} className="flex items-center gap-2 text-gray-400 hover:text-gray-200 transition-colors cursor-pointer">
                  <i className={`${intg.icon} text-lg`}></i>
                  <span className="text-xs font-medium">{intg.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStory;
